<template>
  <div class="adv_order_transporters_single" @click="onClickTransporter">
    <input name="transport_id"
           :value="getTransporters[0].transporter_id"
           type="hidden"
    >

    <AdvOrderTransportersExternal v-if="shouldDisplayTransportersExternal(getTransporters[0].transporter_id)" />

    <SmartPoints v-if="getSmartPointsEnableForTransporter(getTransporters[0])" :transporter="getTransporters[0]" />
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'
import SmartPoints from './SmartPoint/SmartPoints.vue'
import SmartPointMixin from './SmartPoint/SmartPointMixin'
import AdvOrderTransportersExternal from './AdvOrderTransportersExternal.vue'

export default {
  name: 'AdvOrderTransportersSingle',
  components: { AdvOrderTransportersExternal, SmartPoints },
  mixins: [SmartPointMixin],
  computed: {
    ...mapGetters([
      'previewOrderData',
      'getTransporters',
      'getIsExternalTransporterCost',
      'getSelectedTransporterId'
    ])
  },
  watch: {
    getTransporters: {
      handler: function (transporters) {
        if (transporters.length === 1) {
          this.$emit('set-input', this.getTransporters[0].transporter_id)
        }
      },
      deep: true
    }
  },
  async mounted () {
    await this.setPreviewOrderTransporterId(this.getTransporters[0].transporter_id)
    await this.setPayWayAfterTransporterUpdate()
    await this.getExternalTransporterCost()
  },
  methods: {
    ...mapActions(['setPreviewOrderTransporterId', 'getExternalTransporterCost']),
    ...mapMutations([
      'setSelectedTransporterId'
    ]),
    setPayWayAfterTransporterUpdate () {
      if (this.getIsSmartPointOnlyTransporter) {
        if (this.previewOrderData.payWay === 'delivery') {
          this.previewOrderData.payWay = this.previewOrderData.payWays.filter(payWay => payWay.key !== 'delivery')[0].key
        }
      }
    },
    onClickTransporter () {
      if (!this.getIsSmartPointOnlyTransporter) {
        return
      }
      this.setSmartPointIsSelected(true)
      this.resolveDefaultMapInitialization(false)
    },
    shouldDisplayTransportersExternal (transporterId) {
      return this.getIsExternalTransporterCost(transporterId) && Number(transporterId) === Number(this.getSelectedTransporterId)
    }
  }
}
</script>

<style lang="scss" scoped>
.adv_order_transporters_single {
  cursor: pointer;
}
</style>
